import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ForecastingState {
  source: string;
  records: number;
  rows: any[];
}

export const initialState: ForecastingState = {
  source: "by_asin",
  records: 0,
  rows: [],
};

export const forecastingSlice = createSlice({
  name: "forecasting",
  initialState,
  reducers: {
    changeSource: (state: ForecastingState, action: PayloadAction<string>) => {
      state.source = action.payload;
    },
    addRecords: (state: ForecastingState, action: PayloadAction<number>) => {
      state.records = action.payload;
    },
    addRows: (state: ForecastingState, action: PayloadAction<any>) => {
      state.rows = [...state.rows, action.payload];
    },
    deleteRows: (state: ForecastingState) => {
      state.rows = [];
    },
  },
});

export const { changeSource, addRecords, addRows, deleteRows } =
  forecastingSlice.actions;
